export const NOTIFICATION_BY_ACCOUNT_ID_QUERY = `subscription notificationSubscription($accountId: jsonb!, $role: jsonb!,$namespace: jsonb) {
  notifications(where: {
    object_meta: {_contains: $namespace}, 
    _and: [
      {_or: [{notifications_id: {_contains: $accountId}}, {notifications_id: {_contains: $role}}], 
      _not: {mark_as_read: {_contains: $accountId}}}
    ]
    }, order_by: {created_at: desc}) {
    account_id
    created_at
    data
    id
    mark_as_read
    notification_type
    notifications_id
    updated_at
  }
}`;
export const CREATE_NOTIFICATION_QUERY = `mutation createNotification($notification:notifications_insert_input!) {
  insert_notifications_one(object: $notification) {
    account_id
    created_at
    data
    id
    mark_as_read
    notification_type
    notifications_id
    updated_at
  }
}`;

export const BULK_UPDATE_NOTIFICATIONS = `mutation createNotification($notifications: [notifications_insert_input!]!) {
  insert_notifications(objects: $notifications, on_conflict: {constraint: notifications_pkey, update_columns: [ mark_as_read,updated_at]}) {
     returning {
    account_id
    created_at
    data
    id
    mark_as_read
    notification_type
    notifications_id
    updated_at
  }
  }
}`;

export const READ_NOTIFICATIONS_QUERY = `subscription notificationReadSubscription($accountId: jsonb!, $namespace: jsonb) {
  notifications(where: {object_meta: {_contains: $namespace}, _and: {mark_as_read: {_contains: $accountId}}}, order_by: {created_at: desc}) {
    account_id
    created_at
    data
    id
    mark_as_read
    notification_type
    notifications_id
    updated_at
  }
}`;

export const READ_NOTIFICATIONS_QUERY_NOTIFY = `query notificationReadSubscription($accountId: jsonb!, $namespace: jsonb) {
  notifications(where:
      {object_meta: {_contains: $namespace}, _and:{mark_as_read: {_contains: $accountId}}
      }
      , order_by: {created_at: desc}) {
    account_id
    created_at
    data
    id
    mark_as_read
    notification_type
    notifications_id
    updated_at
  }
}`;

export const NOTIFICATION_BY_ACCOUNT_ID_QUERY_NOTIFY = `query notificationSubscription($accountId: jsonb!, $namespace: jsonb) {
  notifications(where: {object_meta: {_contains: $namespace},_and: [{_or: [{notifications_id: {_contains: $accountId}}], _not: {mark_as_read: {_contains: $accountId}}}]}, order_by: {created_at: desc}) {
    account_id
    created_at
    data
    id
    mark_as_read
    notification_type
    notifications_id
    updated_at
  }
}`;
